import React from 'react';
import { PowerOutageScheduleInput } from './PowerOutageScheduleInput';
import SVGImage from '../layout/SVGImage';

interface PowerOutageSchedulLimitItemProps {
  text: string;
  testId?: string;
  className?: string;
  isLock?: boolean;
  isError?: boolean;
  value?: string;
  onChange?: (
    key: keyof PowerOutageScheduleLimitData,
    value: string | boolean | null | number
  ) => void;
}

export const PowerOutageSchedulLimitItem: React.FC<
  PowerOutageSchedulLimitItemProps
> = ({ text, testId, className, isLock, isError, value, onChange }) => {
  const scheduleInputDynamicClass = isError
    ? isLock
      ? 'border-red-main [&>input]:text-light-8'
      : 'border-red-main'
    : isLock
      ? 'border-light-6 [&>input]:text-light-8'
      : '';

  return (
    <div
      data-testid={testId}
      className={`flex h-[42px] w-[186px] items-center justify-center rounded-[7px] bg-white ${className}`}
    >
      <p
        data-testid={`${testId}-power-percent-label`}
        className="noto-medium-3 leading-[23px] text-black"
      >
        {text}
      </p>
      <PowerOutageScheduleInput
        isFloat={true}
        onChange={(value) => (isLock ? null : onChange?.('value', value))}
        className={`ml-[10px] w-[90px] ${scheduleInputDynamicClass}`}
        testId={`${testId}-power-percent-input`}
        suffix="%"
        value={value}
      ></PowerOutageScheduleInput>
      {isLock ? (
        <SVGImage
          onClick={() => onChange?.('isLock', false)}
          testId={`${testId}-power-percent-lock`}
          className="ml-[7px] cursor-pointer"
          width={16}
          height={16}
          name="lock"
        />
      ) : (
        <SVGImage
          onClick={() => onChange?.('isLock', true)}
          testId={`${testId}-power-percent-unlock`}
          className="ml-[7px] cursor-pointer"
          width={16}
          height={16}
          name="unlock"
        />
      )}
    </div>
  );
};
